export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs font-label uppercase tracking-widest text-primary-500 mb-3">
          The Resource Hub
        </p>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight max-w-2xl">
          What Is{' '}
          <span className="font-heading italic text-primary-500">Hipobuy</span>{' '}
          Spreadsheet?
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mt-4 max-w-xl leading-relaxed">
          Hipobuy Spreadsheet is a structured product research database designed to help you discover, compare, and organize product information efficiently — no more scattered searching.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-10">
          <div className="bg-accent-500 rounded-lg p-6 md:p-8 relative overflow-hidden group cursor-default">
            <div className="relative z-10">
              <span className="text-5xl md:text-6xl font-heading font-bold text-background-50">
                14+
              </span>
              <p className="text-sm md:text-base text-background-50/90 mt-2 leading-relaxed">
                Curated product categories with organized spreadsheet databases, covering everything from sneakers to accessories.
              </p>
              <p className="text-xs italic text-background-50/70 mt-4">
                &mdash; Everything you need, sorted
              </p>
            </div>
            <i className="ri-arrow-right-up-line absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 text-lg"></i>
          </div>

          <div className="bg-secondary-500 rounded-lg p-6 md:p-8 relative overflow-hidden group cursor-default">
            <div className="relative z-10">
              <span className="text-5xl md:text-6xl font-heading font-bold text-background-50">
                100K+
              </span>
              <p className="text-sm md:text-base text-background-50/90 mt-2 leading-relaxed">
                Product resources accessed through our organized spreadsheet platform, helping shoppers find what they need faster and smarter.
              </p>
              <p className="text-xs italic text-background-50/70 mt-4">
                &mdash; Growing every day
              </p>
            </div>
            <i className="ri-arrow-right-up-line absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 text-lg"></i>
          </div>
        </div>

        <div className="mt-12 bg-background-50 rounded-lg p-6 md:p-8 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200">
                <th className="text-left py-3 pr-4 font-semibold text-foreground-900">Feature</th>
                <th className="text-left py-3 pr-4 font-semibold text-foreground-400">Normal Searching</th>
                <th className="text-left py-3 font-semibold text-primary-500">Hipobuy Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-100">
                <td className="py-3 pr-4 text-foreground-700 font-medium">Product Discovery</td>
                <td className="py-3 pr-4 text-foreground-400">Slow</td>
                <td className="py-3 text-primary-500 font-medium">Fast</td>
              </tr>
              <tr className="border-b border-background-100">
                <td className="py-3 pr-4 text-foreground-700 font-medium">Organization</td>
                <td className="py-3 pr-4 text-foreground-400">Random</td>
                <td className="py-3 text-primary-500 font-medium">Categorized</td>
              </tr>
              <tr className="border-b border-background-100">
                <td className="py-3 pr-4 text-foreground-700 font-medium">Research Process</td>
                <td className="py-3 pr-4 text-foreground-400">Time-consuming</td>
                <td className="py-3 text-primary-500 font-medium">Efficient</td>
              </tr>
              <tr className="border-b border-background-100">
                <td className="py-3 pr-4 text-foreground-700 font-medium">Product Comparison</td>
                <td className="py-3 pr-4 text-foreground-400">Difficult</td>
                <td className="py-3 text-primary-500 font-medium">Simple</td>
              </tr>
              <tr>
                <td className="py-3 pr-4 text-foreground-700 font-medium">Beginner Experience</td>
                <td className="py-3 pr-4 text-foreground-400">Complex</td>
                <td className="py-3 text-primary-500 font-medium">Easy</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}